import React, {Component} from 'react';
import {
    Button,
    Form,
    Container,
    Header,
    Grid
} from 'semantic-ui-react';

import Alert from "../../components/extras/Alert";
import CloseBoxData from "../../data/CloseBoxData";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

const moneyMask = createNumberMask({
    prefix: '$',
});

class OpenBoxForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            amount: 0,
            amount_error: false,
            sending: false
        };

        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.amount === "" || this.state.amount < 0) {
            this.setState({amount_error: true});
        } else {
            this.setState({sending: true});
            let data = {amount: this.state.amount};
            CloseBoxData.open(data, (res) => {
                if (res.open) {
                    this.props.callbackOpen();
                } else {
                    this.setState({sending: false});
                    window.location.reload();
                }
            });
        }
    }

    handleAmountChange(event) {
        let amount = isNaN(parseFloat(event.target.value.replace(/\D/g, ''))) ? '':parseFloat(event.target.value.replace(/\D/g, ''));
        this.setState({amount});
        if (event.target.value.trim() === '' || event.target.value < 0) {
            this.setState({amount_error: true});
        } else {
            this.setState({amount_error: false});
        }
    };

    render() {
        return (
            <Container>
                <Grid stackable centered>
                    <Grid.Row columns={2}>
                        <Grid.Column>
                            <Header as='h2'>
                                <Header.Content>
                                    Apertura de Caja
                                </Header.Content>
                            </Header>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Input label='Valor Apertura'
                                            error={this.state.amount_error}
                                            children={
                                                <MaskedInput
                                                    mask={moneyMask}
                                                    value={this.state.amount}
                                                    placeholder='Valor Apertura'
                                                    onChange={this.handleAmountChange}
                                                />
                                            }
                                />
                                <Button primary fluid disabled={this.state.sending} loading={this.state.sending}
                                        type="submit" content="Abrir Caja"/>
                            </Form>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Alert ref='alert'/>
            </Container>

        );
    }
}

export default OpenBoxForm;



// WEBPACK FOOTER //
// ./src/components/open_box/OpenBoxForm.js